import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AppProvider } from "./context/AppContext";
import { AppThemeProvider } from "./context/ThemeContext";
import { FollowNotifications } from "./components/FollowNotifications";
import "./styles.css";
import "./mui-refresh.css";
import "./follow-notifications.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppThemeProvider>
      <BrowserRouter>
        <AppProvider>
          <App />
          <FollowNotifications />
        </AppProvider>
      </BrowserRouter>
    </AppThemeProvider>
  </StrictMode>
);
